import React, { FunctionComponent, MouseEvent } from 'react';
import { Menu as MUiMenu, MenuItem } from '@mui/material';
import styles from './Menu.styles';
import { IMenuOption } from '../../interfaces/menuOption.interface';
import useStyles from './Menu.styles';

interface IProps {
  anchorEl: Element | null;
  options: IMenuOption[];
  setAnchorEl: Function;
}

const Menu: FunctionComponent<IProps> = ({
  anchorEl,
  setAnchorEl,
  options,
}) => {
  const classes = useStyles();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onOptionClick = (action: (event: MouseEvent) => void) => (
    e: MouseEvent
  ) => {
    action(e);
    handleClose();
  };

  return (
    <MUiMenu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      className={classes.menu}
    >
      {options
        .filter((option) => !option.hidden)
        .map((option) => (
          <MenuItem
            key={option.text}
            onClick={onOptionClick(option.action)}
            className={classes.menuItem}
            data-testid={option.testid}
          >
            {option.text}
          </MenuItem>
        ))}
    </MUiMenu>
  );
};

export default Menu;
